module.exports = __webpack_public_path__ + "static/media/exchange.c52e942b.png";